import { useAtom } from 'jotai';
import { storageUrl } from '../firebase';
import { userData } from '../states/planner';
import { Link, Navigate, useParams } from 'react-router-dom';
import useSites from '../hooks/useSites';
import doubletap from '../assets/doubletap.gif';
import doubletapMobile from '../assets/doubletap_mobile.gif';
import AdminSite from './AdminSite';

export const AdminPage = () => {
  const { company, sitename } = useParams();
  const [sites] = useSites();
  const [user] = useAtom(userData);

  if (sitename) {
    return <AdminSite />;
  }

  return (
    <div className="p-5">
      {/* Sites Grid */}
      <div className="flex flex-wrap justify-center gap-6">
        {sites.map(site => {
          if (user && !site.admins.includes(user.id)) return null;
          if (site.disabled && process.env.NODE_ENV !== 'development') return null;

          return (
            <Link key={site.siteid} to={`/${company}/admin/${site.sitename}`}>
              <div className="flex h-52 w-52 transform flex-col items-center justify-between rounded-2xl border border-gray-200 bg-white p-3 font-medium text-gray-700 shadow-md transition-transform hover:scale-105 hover:bg-gray-50 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-400">
                <p className="text-center text-base font-semibold">{site.sitename}</p>

                {site.overviewpicture ? (
                  <img
                    src={storageUrl(site.overviewpicture)}
                    alt="floorplan"
                    className="mt-2 h-32 w-40 rounded-xl object-cover"
                  />
                ) : (
                  <div className="mt-2 flex h-32 w-40 items-center justify-center rounded-xl bg-gray-100">
                    <span className="text-sm text-gray-500">Ingen bild</span>
                  </div>
                )}
              </div>
            </Link>
          );
        })}
      </div>

      {/* Hint + Demo */}
      <div className="mt-10 flex flex-col items-center justify-center text-center">
        <p className="max-w-md text-sm text-gray-600">
          💡 Om du är inloggad kan du dubbelklicka på statusen för att redigera den direkt i bostadsväljaren. Se exempel
          nedan:
        </p>
        <img
          src={doubletap}
          alt="doubletap"
          className="m-5 hidden max-w-full rounded-3xl border-2 border-gray-300 shadow-sm md:block"
        />
        <img
          src={doubletapMobile}
          alt="doubletap"
          className="m-5 block max-w-full rounded-3xl border-2 border-gray-300 shadow-sm md:hidden"
        />
      </div>
    </div>
  );
};
